import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C7.439 22 4 20.065 4 17.5V6.00003H4.047C4.39672 4.70028 5.33486 3.63927 6.582 3.13303C8.27819 2.34782 10.1313 1.9603 12 2.00003C16.561 2.00003 20 3.93503 20 6.50003C19.999 6.66779 19.9829 6.83513 19.952 7.00003H20V17.5C20 20.065 16.561 22 12 22ZM5.777 9.39403V17.5C5.777 18.519 8.2 20 12 20C15.8 20 18.222 18.519 18.222 17.5V9.39403C16.3471 10.5202 14.1857 11.0781 12 11C9.81398 11.078 7.6523 10.5201 5.777 9.39403ZM12 4.00003C8.2 4.00003 5.777 5.48103 5.777 6.50003C5.777 7.51903 8.2 9.00003 12 9.00003C15.8 9.00003 18.222 7.51903 18.222 6.50003C18.222 5.48103 15.8 4.00003 12 4.00003Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Cylinder"
);
